{
  "BuyPlayer_BuyOffer": "Buy",
  "BuyPlayer_InsufficientFundsTitle": "Insufficient funds",
  "BuyPlayer_NoDiscount": "no discount",
  "BuyPlayer_Success": "Buy successfull",
  "Error_AppUpdateRequired": "Update your app",
  "Error_ConflictDuplicateLogin": "Duplicate login",
  "Error_NetworkTimeout": "Check your internet connection",
  "Error_TryLater": "Try again later",
  "Error_LoginFailed": "Login failed",
  "GameLoopState_Active": "During gameday",
  "GameLoopState_Post": "After gameday",
  "GameLoopState_Pre": "Pre gameday",
  "General_Cancel": "Cancel",
  "General_Ok": "OK",
  "Lineup_Formation_1343": "3-4-3",
  "Lineup_Formation_1352": "3-5-2",
  "Lineup_Formation_1433": "4-3-3",
  "Lineup_Formation_1442": "4-4-2",
  "Lineup_Formation_1451": "4-5-1",
  "Lineup_Formation_1532": "5-3-2",
  "Lineup_InvalidLineup": "Invalid Lineup",
  "LoadingOverlay_Title": "Loading...",
  "AuthErrorPleaseContact": "For questions please contact",
  "PlayerCard_Age": "{0} years",
  "PlayerCard_AgeLabel": "Age",
  "PlayerCard_Height": "{0} cm",
  "PlayerCard_HeightLabel": "Height",
  "PlayerCard_NationalityLabel": "Country",
  "PlayerCard_ShirtNumberLabel": "Number",
  "PlayerCard_TeamLabel": "Team",
  "PlayerCard_Weight": "{0} kg",
  "PlayerCard_WeightLabel": "Weight",
  "PlayerDetails_AddToLineup": "Add to lineup",
  "PlayerDetails_AssignedTo": "Assigned to",
  "PlayerDetails_Back": "Back",
  "PlayerDetails_BuyHeadline": "Offer",
  "PlayerDetails_LockCountdown": "Transferlock",
  "PlayerDetails_RemoveFromLineup": "Drop",
  "PlayerDetails_Roster": "Roster",
  "PlayerFilter_Name": "Name",
  "PlayerFilter_Price": "Price",
  "PlayerFilter_Rating": "Rating",
  "PlayerFilter_Sort": "Sort",
  "PlayerFilter_Value": "Value",
  "PlayerFilter_ValueShort": "Value",
  "PlayerFilter_ValueFrom": "From",
  "PlayerFilter_ValueTo": "To",
  "PlayerFilter_Search": "Player name",
  "PlayerGroup_ShowMore": "Show more",
  "PlayerPosition_bench": "Bench",
  "PlayerPosition_defender": "Defender",
  "PlayerPosition_forward": "Forward",
  "PlayerPosition_goalkeeper": "Goalkeeper",
  "PlayerPosition_midfielder": "Midfielder",
  "PlayerPosition_unknown": "Unknown",
  "Roster_RosterTitle": "My roster",
  "RosterList_EmptyPosition": "You don't have any players for this position",
  "RosterList_EmptyPositionButton": "Go to transfer market",
  "SellPlayer_IsInLineupError": "Players that are used in lineup can not be sold while in a live matchday.",
  "SellPlayer_LockedError": "The player is locked. Try later.",
  "SellPlayer_Sell": "Sell",
  "SellPlayer_SellMore": "Sell",
  "StatusInformation_Reload": "Reload",
  "Transaction_BoughtLabel": "Bought",
  "TransactionNotification_AttentionWarning": "Warning!",
  "TransactionNotification_BoughtHeadline": "Bought!",
  "TransactionNotification_BoughtText": "{0} (x{1}) for {2}",
  "TransactionNotification_HardAndSoftPrice": "{0} and {1}",
  "TransactionNotification_SoldHeadline": "Sold!",
  "TransactionNotification_SoldText": "{0} (x{1}) for {2}",
  "UserAuthenticateFailed": "Login failed",
  "UserSettings_Off": "Off",
  "UserSettings_On": "On",
  "UserSettings_Sound": "Sound",
  "UserSettings_Title": "Settings",
  "UserSettings_Vibration": "Vibration",
  "ActionMenu_SubstituteOut": "Take out",
  "Availability_available": "Now",
  "Availability_today": "Today",
  "Availability_tomorrow": "Tomorrow",
  "Error_GameLoopState_Locked": "The game has just frozen. You can find out about the further steps under \"More information\".",
  "ExperienceLog_Reward": "Reward",
  "ExperienceLog_Start": "Start",
  "GamedayPlayer_Status_bench": "Bench",
  "GamedayPlayer_Status_bench_Unsure": "maybe bank",
  "GamedayPlayer_Status_inactive": "Inactive",
  "GamedayPlayer_Status_inactive_Unsure": "maybe not in roster",
  "GamedayPlayer_Status_questionable": "Questionable",
  "GamedayPlayer_Status_questionable_Unsure": "maybe questionable",
  "GamedayPlayer_Status_starter": "Starter",
  "GamedayPlayer_Status_starter_Unsure": "maybe starter",
  "GamedayPlayer_Status_unknown": "Unknown",
  "GamedayPlayer_Status_unknown_Unsure": "Unknown",
  "Gameloop_AdminGift": "Gift",
  "Gameloop_ClaimGiftFailedText": "You can claim the gift only after the stated period!",
  "Gameloop_LoginGift": "Daily reward",
  "General_AreYouSure": "Are you sure?",
  "General_BuyOffer": "Buy",
  "General_Close": "Close",
  "General_GamedateSeparatorForDays": "{0} - {1}",
  "General_GamedateSeparatorForMonths": "{0} - {1}",
  "General_GamedayCurrent": "Current Gameday",
  "General_Info": "Info",
  "General_No": "No",
  "General_Warning": "Warning!",
  "General_Yes": "Yes",
  "GeneralDate_CountdownDay": "{0} day {1}:{2}",
  "GeneralDate_CountdownDays": "{0} days {1}:{2}",
  "GeneralDate_CountdownDaysText": "{0} days, {1}h",
  "GeneralDate_CountdownDayText": "{0} day, {1}h",
  "GeneralDate_CountdownHoursText": "{0}h {1}min",
  "GeneralDate_CountdownMinutesText": "{0}min",
  "GeneralDate_CountdownOfferText_One": "New offer in {0}",
  "GeneralDate_CountdownOfferText_Other": "New offers in {0}",
  "GeneralDate_CountdownSecondsText": "<1min",
  "GeneralDate_Now": "Now",
  "GiftboxOverlay_Text": "Get your reward!",
  "GiftboxOverlay_Title": "Nice!",
  "GiftboxPreviewOverlay_Title": "Gift for this area",
  "GiftboxType_AdminGift": "Present",
  "GiftboxType_Combined": "Reward",
  "GiftboxType_GlobalRank": "Rank",
  "GiftboxType_GlobalTableSection": "Table section",
  "GiftboxType_GlobalTopManager": "Top Manager",
  "GiftboxType_GroupWinner": "Group winner",
  "GiftboxType_LevelUp": "Level up",
  "GiftboxType_LoginGift": "Daily reward",
  "Lineup_CanNotParticipateInMatchay": "You are not playing at this matchday!\n\nAfter this matchday you can create your lineup.",
  "Lineup_Formation_FREE": "Free Formation",
  "Lineup_Formation_FREE_short": "Free lup.",
  "Lineup_Formation_FREE_very_short": "Free",
  "Lineup_PlayerBoostRemoveConfirm": "Do you really want to remove the captain? The card \"captain\" will be lost.",
  "RankingGroup_UserEmptyGroup": "No Group",
  "Onboarding_LastButton": "Los geht's!",
  "Onboarding_NextButton": "Next",
  "Overlay_ButtonActivate": "Activate",
  "Player_Status_active": "Active",
  "Player_Status_inactive": "Inactive",
  "Player_Status_questionable": "Questionable",
  "Player_Status_unknown": "Unknown",
  "PlayerDetails_SellEstimatedCost": "Total payed cost:",
  "PlayerFilter_Points": "Last Game",
  "PlayerFilter_PointsGameday": "Current Gameday",
  "PlayerPennant_Description": "Admit one to use in lineup",
  "PlayerPennant_Title": "Playercard",
  "PlayerPosition_free": "free lineup",
  "PlayerPosition_groupInLineup": "Used Players",
  "PlayerPosition_groupLocked": "Locked Players",
  "PlayerRatingInfo_Title": "Rating",
  "PlayerStats_NextOpponentTitle": "Next Opponent",
  "PlayerStats_PositionTitle": "Position",
  "PlayerStats_StatusTitleLineup": "Lineup",
  "PlayerStats_StatusTitlePlayer": "Player Status",
  "PlayerStats_StatusTitlePreLineup": "Predicted Lineup",
  "PlayerStats_TrendTitle": "Trend",
  "PlayerStatsKey_RatingAndPointsTitle": "Points",
  "PlayerStatsKey_StatusText": "Offical data\nkicker's prediction",
  "PlayerStatsKey_StatusTitle": "Status",
  "Ranking_CalculatingList": "This list for this matchday is calculated.",
  "Ranking_SegmentGroup": "Group",
  "Ranking_TableEntry": "{0}. rank",
  "Ranking_TableEntryShort": "{0}. r.",
  "Ranking_TableHeaderPoints": "Points",
  "Ranking_TableHeaderPointsRange": "min.-max. points",
  "Ranking_TableHeaderUserCount": "manager count",
  "Ranking_TableHeaderUserName": "Name",
  "Ranking_TableLegendText1": "Status: {0}",
  "Ranking_TableManagerTitle": "Manager Rankings",
  "Ranking_TableMyEntryPoints": "Gamday points",
  "Ranking_TableMyEntryRanking": "Manager ranking placement",
  "Ranking_TableMyEntryRankingNotFound": "You have no placement in this ranking. Let at least one gameday pass with your participation.",
  "Ranking_Title": "Standing",
  "Ranking_TopManagersTitle": "Top 3 Managers",
  "RankingGroup_ActionChangeNameButton": "Change name",
  "RankingGroup_ActionCreateButton": "Create group",
  "RankingGroup_ActionCreateText": "Choose a name for your new group",
  "RankingGroup_ActionCreateTitle": "Create group",
  "RankingGroup_ActionGenerateJoinLinkButton": "Invite friends",
  "RankingGroup_ActionGenerateJoinLinkText": "Send the link to your friends you want to invite. You can invite multiple people with one link. The link is valid until the kick-off of the first game of the season. After first kick-off generated links are limited to 72 hours.",
  "RankingGroup_ActionKickMemberSuccess": "This player has been kicked from the group!",
  "RankingGroup_ActionLeaveButton": "Leave group",
  "RankingGroup_ActionLeaveText": "Do you really want to leave group \"{0}\"?",
  "RankingGroup_ActionMakeAdminSuccess": "This player is now an admin too",
  "RankingGroup_ActionManageMembershipText": "Manage role and membership",
  "RankingGroup_ActionMemberAssignAdminButton": "Assign admin role",
  "RankingGroup_ActionMemberKickButton": "Kick",
  "RankingGroup_ActionMemberRevokeAdminButton": "Revoke admin role",
  "RankingGroup_ActionRenameText": "Choose a new name for your group",
  "RankingGroup_ActionRenameTitle": "Rename group",
  "RankingGroup_ActionRevokeAdminSuccess": "This Player is no longer an admin",
  "General_NotificationSuccess": "All right!",
  "RankingGroup_GroupNameInvalid": "The name is invalid",
  "RankingGroup_JoinAlertText": "Do you want to join the group?",
  "RankingGroup_JoinAlertTitle": "join a group",
  "RankingGroup_JoinLinkShareTitle": "Invite for group",
  "RankingGroup_NewOrInactiveMembers": "New and inactive members",
  "RankingGroup_NoMembershipText": "You can create a group and invite your friends.",
  "RankingGroup_NotificationGroupJoined": "Group joined",
  "RankingGroup_ValidationAlreadyMember": "You are already a member of too many groups. You have reached the maximum of 10 groups.",
  "RankingGroup_ValidationAuthorizationFailed": "Authorization failed",
  "RankingGroup_ValidationGroupFull": "This group has reached the maximum number of members. An administrator has to remove a member first.",
  "RankingGroup_ValidationInvalidGroupName": "Invalid groupname",
  "RankingGroup_ValidationInvalidToken": "Invalid or expired invite",
  "Roster_ConfirmSellAllPlayers": "Do you really want to sell all your players?\nSelling a team and buying and placing all of your player bets yourself for the next match day?",
  "Roster_HodlAllButton": "Keep",
  "Roster_MyRoster": "Open roster",
  "Roster_OKButton": "Continue",
  "Roster_PlayerIsLocked": "This player is locked right now. Click \"OK\" to view his profile.",
  "Roster_PlayerIsUnclaimed": "This player is not activated. Click \"OK\" to view his profile and activate.",
  "Roster_SellAllButton": "Sell all",
  "Roster_SellAllPlayersSuccessText": "All players have been sold",
  "Roster_SellAllPlayersSuccessTitle": "Done!",
  "RosterList_EmptyPositionUsedElsewhere": "All players are used or locked.",
  "RoundEvaluation_ClaimReward": "Claim reward",
  "RoundEvaluation_MainTitle": "Analysis",
  "RoundEvaluation_ReviewReward": "Review reward",
  "RoundEvaluation_ShowStatistics": "Show roster",
  "RoundEvaluation_Statistics_BenchPlayers": "On the bench: {0}/{1}",
  "RoundEvaluation_Statistics_Formation": "Formation",
  "RoundEvaluation_Statistics_Points": "Points",
  "RoundEvaluation_Statistics_RatedPlayers": "Rated: {0}/{1}",
  "RoundEvaluation_TopPlayersHeadline": "Your Top {0}",
  "SellPlayer_IsInLineupConfirm": "This player is currently in your lineup. Do you want to remove this player form the lineup and sell him?",
  "Shop_CurrencyConversionHeadline": "Exchange currency",
  "Shop_CurrencyConversionInfo_One": "Last offer",
  "Shop_CurrencyConversionInfo_Other": "{0} offers left",
  "Shop_CurrencyConversionText": "Offers get reset after every matchday.",
  "StatusInformation_Title": "Status Information",
  "Timeline_ForceSell": "Force sell",
  "Timeline_PlayerLock": "Lock",
  "Transfer_InvalidTutorialPlayerSelection": "This player is not an attacker",
  "Transfer_TeamsLabel": "Teams",
  "Transfer_TransferTitle": "Transfermarket",
  "UserPhotoOverlay_CameraButton": "Camera",
  "UserPhotoOverlay_Description": "Do you want to take a new photo or select one from your library?",
  "UserPhotoOverlay_PhotoLibraryButton": "Photo Library",
  "UserPhotoOverlay_Title": "User photo",
  "UserSettings_AccountTransferButton": "Link devices",
  "UserSettings_AccountTransferEnterCodeText": "Type the code from the old device",
  "UserSettings_AccountTransferEnterCodeTitle": "Enter code",
  "UserSettings_AccountTransferFailed": "Device linking has failed!",
  "UserSettings_AccountTransferNewDevice": "New device",
  "UserSettings_AccountTransferOldDevice": "Old device",
  "UserSettings_AccountTransferText": "To start, tap the right options.\nThis is a:",
  "UserSettings_CodeGeneratorFailed": "Generating the code failed!",
  "UserSettings_ConnectedToGameCenter": "Connected with GameCenter",
  "UserSettings_ConnectToGameCenterButton": "Connect with GameCenter",
  "UserSettings_DataProtectionButton": "Data Protection",
  "UserSettings_DisconnectFromCurrentAccount": "<color=#ff0000>The access to your current account\n<b>{0}</b>\nwill be lost",
  "UserSettings_FAQButton": "FAQ",
  "UserSettings_ImprintButton": "Imprint",
  "UserSettings_InvalidUserName": "Invalid username. Length should be between 3 - 32 characters, special charecters are not allowed.",
  "UserSettings_MusicButton": "Music",
  "UserSettings_RequestDebugging": "Request Debugging",
  "UserSettings_SFXButton": "SFX",
  "UserSettings_SupportButton": "Support",
  "UserSettings_TermsButton": "Terms",
  "UserSettings_TutorialButton": "Watch Tutorial",
  "UserSettings_UserImageUploadFailed": "User image upload failed",
  "UserSettings_YourCodeTitle": "Code for the new device",
  "UserSettings_YourProfile": "Your profile",
  "ActionMenu_ShareLineup": "Share lineup",
  "ActionMenu_ShowOpponentLineup": "Show lineup",
  "ActionMenu_ShowRoundEvaluation": "Show evaluation",
  "Gameloop_ConsolationGift": "Consolation gift",
  "Gameloop_DuelConsolationDescription": "Battle Streak Lost",
  "Gameloop_DuelWinnerDescription": "Your {0}. Victory!",
  "Gameloop_DuelWinnerTitle": "Battle won",
  "Gameloop_ForceSell": "Forced sale",
  "Gameloop_GroupRankingRewardGift": "Your Group",
  "Gameloop_RankingRewardGift": "Manager table",
  "General_Respond": "Respond",
  "GeneralDate_CountdownOfferTextEnds_One": "Offer ends in {0}",
  "LineupShare_Text": "Check out my lineup! {0}",
  "LineupShare_Title": "Matchday lineup",
  "RankingGroup_ActionMemberDetails": "View Details",
  "RankingGroup_TableHeaderLevel": "Level",
  "Roster_CanOnlySellInGeneralLoop": "Placed player stakes cannot be sold right now!",
  "UserSettings_GeneralSuccess": "Looks good!",
  "UserSettings_NotificationsTitle": "Alarm",
  "UserSettings_OnboardingButton": "Updates",
  "UserSettings_UserImageUploadSuccess": "Your picture has been updated",
  "Banner2_Title_Bold_1": "Best 2nd League",
  "Banner2_Title_Bold_2": "best manager game!",
  "Banner2_Title_Light_1": "The",
  "Banner2_Title_Light_2": "ever deserves the",
  "Banner_Button": "Start now",
  "Banner_Description": "Try the Matchday-Manager from kicker!",
  "Banner_Title": "Switch live every weekend?",
  "BuyPlayer_InsufficientFunds": "Not enough budget {0}",
  "BuyPlayer_NoMarketValue": "This player lacks a price.",
  "Error_TransferLoginWithKicker": "Your kicker account already has a squad for this season. The squad you put together before logging in was therefore not carried over.",
  "ErrorOverlay_SubTitle": "Could not load the application due to an error",
  "FavoriteList_Add": "Add",
  "FavoriteList_EmptyPosition": "No player at this position",
  "FavoriteList_IsFullText": "Is full",
  "FavoriteList_Remove": "Remove",
  "Favorites_FavoritesTitle": "Favorites",
  "General_ErrorRestart": "Due to an error we have to restart the error, sorry.",
  "General_MoreInformation": "More information",
  "General_NotFound": "Not Found",
  "General_SomethingWentWrong": "Something went wrong",
  "Global_MillionsAbbreviation": "Mln",

  "Lineup_AdditionalInformationAssignments": "Assignments",
  "Lineup_AdditionalInformationPoints": "Points",
  "Lineup_AdditionalInformationPrice": "Price",
  "Lineup_AdditionalInformationRating": "Total",

  "Lineup_AdditionalInformationPointsRound": "Last match day",
  "Lineup_AdditionalInformationPointsRating": "Last Season",
  "Lineup_AdditionalInformationPointOnMyAssignments": "My Assignments",
  "Lineup_AdditionalInformationAssignmentsMyAssignments": "My Assignments",
  "Lineup_AdditionalInformationAssignmentsTotal": "Season",
  "Lineup_AdditionalInformationAssignmentsAveragePerAssignments": "Avg. Points per Assignment",

  "Lineup_BuyPlayers": "Buy players",
  "Lineup_CanNotChangeLineupDuringCurrentPhase": "Cannot change lineup during current gameloop phase",
  "Lineup_Committed": "Lineup saved",
  "Lineup_AdLabel": "– Ad –",
  "Lineup_CommittedToBench": "Bench",
  "Lineup_CommittedToField": "Field",
  "Lineup_EmptyBench": "Empty",
  "Lineup_EmptyLineupMessage": "You don't have a roster yet",
  "Lineup_GameloopStateLocked": "You can not join during a running season.",
  "Lineup_HideBench": "Hide Bench",
  "Lineup_Legend": "Legend",
  "Lineup_LegendActive": "Active",
  "Lineup_LegendActualLineup": "Actual lineup",
  "Lineup_LegendBench": "Bench",
  "Lineup_LegendColors": "Colors",
  "Lineup_LegendForecast": "Forecast",
  "Lineup_LegendInactive": "Inactive",
  "Lineup_LegendPictograms": "Pictograms",
  "Lineup_LegendQuestionable": "Questionable",
  "Lineup_LegendTeamTransfer": "Team change",
  "Lineup_LegendTeamTransferLeftSeason": "Left the league",
  "Lineup_LegendTeamTransferOriginTeam": "Origin team",
  "Lineup_LegendTeamTransferRemainedInSeason": "Stayed in the league",
  "Lineup_MaxForTeam": "You already have three players from {team.name} in your lineup.",
  "Lineup_MaxForTeamTitle": "Maximum number of players reached",
  "Lineup_RandomRoster": "Random roster",
  "Lineup_ShareOption1": "Post / Messenger (1:1)",
  "Lineup_ShareOption2": "Story - Lineup (9:16)",
  "Lineup_ShareOption3": "Story - Substitutes (9:16)",
  "Lineup_ShareOption4": "Print (A4)",
  "Lineup_ShareTitle": "Share Lineup",
  "Lineup_ShowBench": "Show Bench",
  "Lineup_Substitute": "substitute",
  "Lineup_SubstitutionDone": "substitution done",
  "LoadingOverlay_Database": "Fetching match and player data…",
  "LoadingOverlay_Login": "Login…",
  "LoadingOverlay_RedirectToSeason": "Redirecting to default season…",
  "LoadingOverlay_SeasonData": "Fetching leagues data…",
  "MatchState_Halted": "canc.",
  "Navigation_GlobalRanking": "Global ranking",
  "Navigation_Group": "Group",
  "Navigation_Lineup": "Lineup",
  "Navigation_Live": "Gameday",
  "Navigation_TransferMarket": "Transfer market",
  "Navigation_Classic": "Managerspiel Classic",
  "Navigation_Interactive": "Managerspiel Interactive",
  "NetworkErrorVerifyEmailAddress": "Please verify your email",
  "PlayerCard_Position": "Position",
  "PlayerCard_Price": "Price",
  "PlayerCard_PriceByRating": "Points / Price",
  "PlayerDetails_Grade": "Grade",
  "PlayerDetails_Match": "Match",
  "PlayerDetails_Matches": "Matches",
  "PlayerDetails_Per_Match": "per Match",
  "PlayerDetails_Point": "Point",
  "PlayerDetails_Points": "Points",
  "PlayerDetails_PointsAssists": "Points Assists",
  "PlayerDetails_PointsAverageGrade": "Average Grade",
  "PlayerDetails_PointsBreakdown": "Points breakdown",
  "PlayerDetails_PointsCard": "Card",
  "PlayerDetails_PointsCards": "Points Cards",
  "PlayerDetails_PointsCardsRed": "Red",
  "PlayerDetails_PointsCardsYellowRed": "Yellow-Red",
  "PlayerDetails_PointsCardsYellowRedAndRed": "Yellow-Red/Red",
  "PlayerDetails_PointsCleanSheet": "Points Clean Sheet",
  "PlayerDetails_PointsGoals": "Points Goals",
  "PlayerDetails_PointsGrade": "Points Grade",
  "PlayerDetails_PointsJoker": "Points Joker",
  "PlayerDetails_PointsJokers": "Jokers",
  "PlayerDetails_PointsMVP": "Points MVP",
  "PlayerDetails_PointsStarter": "Points Starter",
  "PlayerDetails_PointsStarters": "Starter",
  "PlayerDetails_ProfileLink": "Profile",
  "PlayerDetails_RoundRating": "Round Rating",
  "PlayerDetails_SeasonRating": "Season rating",
  "PlayerDetails_Stats": "Statistics",
  "PlayerFilter_SearchByName": "Search by player name...",
  "PlayerFilter_SearchByNameShort": "Search...",
  "Ranking_Heading": "Ranking",
  "Ranking_EmptyList": "No entries",
  "Ranking_NoRankingsAvailable": "No rankings available",
  "Ranking_SeasonNotStarted": "No round has passed",
  "Ranking_SegmentRound": "Round Ranking",
  "Ranking_SegmentSeason": "Season Ranking",
  "Ranking_SegmentRound_UserDetail": "Round Points",
  "Ranking_SegmentSeason_UserDetail": "Season Points",
  "Ranking_TableHeaderRank": "Rank",
  "RankingGroup_ActionChangeNameSuccessText": "You've successfully updated this group's name",
  "RankingGroup_ActionChangeNameSuccessTitle": "Successfully updated group name",
  "RankingGroup_ActionCopyButton": "Copy to clipboard",
  "RankingGroup_ActionCopySuccess": "Done!",
  "RankingGroup_ActionCopySuccessText": "URL was copied",
  "RankingGroup_ActionGenerateJoinLinkDescription": "Send invite link",
  "RankingGroup_ActionKickMemberText": "Kick {0}?",
  "RankingGroup_ActionLeaveSuccessText": "You've successfully left this group",
  "RankingGroup_ActionLeaveSuccessTitle": "Left the group",
  "RankingGroup_ActionDeleteGroupButton": "Delete group",
  "RankingGroup_ActionDeleteGroupConfirmText": "Are you sure you want to delete the group \"{0}\"? All members will be removed.",
  "RankingGroup_ActionDeleteGroupSuccessText": "The group has been deleted.",
  "RankingGroup_ActionDeleteGroupSuccessTitle": "Done!",
  "RankingGroup_ActionMakeAdminText": "Make {0} an admin?",
  "RankingGroup_ActionShareButton": "Share",
  "Roster_ExportAllPlayers": "Export all players",
  "Roster_FillUpPlayers": "Fill up roster",
  "Roster_FillUpPlayersImpossible": "It's not possible",
  "Roster_SellAllPlayers": "Sell all",
  "Roster_SellAllPlayersWarning": "Warning, sell all?",
  "Roster_WinterTransferButton": "Extra Transfer",
  "RoundResult_Heading": "Gameday Points",
  "RoundResult_PointsMaximum": "Maximum",
  "RoundResult_PointsMissedOut": "Missed out",
  "RoundResult_YourPoints": "Achieved",
  "RulesHelp_Budget": "Budget\nx",
  "RulesHelp_GameLocked": "Closed\nx",
  "RulesHelp_PlayerWarning": "Player Warning\nx",
  "RulesHelp_Title": "Rules Info",
  "RulesHelp_TradesLeft": "Trades left...",
  "RulesHelp_TradesLeftBoughtPlayers": "Bought Players",
  "RulesHelp_TradesLeftSoldPlayers": "Sold Players",
  "RulesHelp_TransferMarketLocked": "Transfermarket\nx",
  "RulesHelp_WinterTransfer": "Trades (a).",
  "Stats_Filter": "Filter",
  "Stats_Matchday": "Matchday",
  "Stats_MillionsAbbreviation": "M",
  "Stats_OrderByPopularity": "Popularity",
  "Stats_OrderByPrice": "Price",
  "Stats_OrderByPricePointRatio": "Price-Point Ratio",
  "Stats_OrderByRating": "Rating",
  "Stats_OrderByStatus": "Status",
  "Stats_Position": "Position",
  "Stats_PoweredBy": "Powered By",
  "Stats_Team": "Team",
  "Stats_Timeframe": "Timeframe",
  "Stats_Title": "Stats",
  "StatusBar_Balance": "Your budget",
  "StatusBar_EvaluatingRound": "Evaluating Gameday",
  "StatusBar_InactiveSeason": "Past Season",
  "StatusBar_PlayerCount": "Your roster",
  "StatusBar_PlayerWarning": "Player Warning",
  "StatusBar_PointsReached": "Points Reached",
  "StatusBar_TradesLeft": "Trades Left",
  "StatusBar_Transfermarket": "Transfermarket",
  "StatusBar_TransfermarketLocked": "Closed",
  "StatusBar_TrialAccount": "Not signed in",
  "Transfer_FilterAllTeams": "All Teams",
  "TransferMarket_FullBench": "Bench is full, please change your lineup before purchasing another player.",
  "TransferMarket_FullBenchTitle": "Bench is full",
  "TransferMarket_FullLedger": "You can not buy another player for {position}.",
  "TransferMarket_FullLedgerTitle": "Full ledger",
  "TransferMarket_MarketNotOpen": "The transfer market is locked",
  "TransferMarket_MaxForTeam": "You can not buy another player from {team}",
  "TransferMarket_MaxForTeamOnPitch": "You can not buy another player from {team} to place on the pitch",
  "TransferMarket_MaxForTeamOnPitchTitle": "Maximum numbers of players reached",
  "TransferMarket_MaxForTeamTitle": "Maximum number of players reached",
  "TransferMarket_NoRestrictedSalesLeft": "You cannot sell this player as you don't have any trades left.",
  "TransferMarket_NoRestrictedSalesLeftTitle": "Cannot sell player",
  "TransferMarket_PlayerLeftSeason": "{player} no longer plays in this league and cannot be signed.",
  "TransferMarket_PlayerLeftSeasonTitle": "Player no longer in the league",
  "TransferMarket_OrderByFirstName": "Order by first name",
  "TransferMarket_OrderByFirstName_selected": "first name",
  "TransferMarket_OrderByLastName": "Order by last name",
  "TransferMarket_OrderByLastName_selected": "last name",
  "TransferMarket_OrderByPoints": "Order by points",
  "TransferMarket_OrderByPoints_selected": "points",
  "TransferMarket_OrderByPrice": "Order by price",
  "TransferMarket_OrderByPrice_selected": "price",
  "TransferMarket_OrderByRating": "Order by rating",
  "TransferMarket_OrderByRating_selected": "rating",
  "TransferMarket_OrderBy_Direction_ASC": "ascending",
  "TransferMarket_OrderBy_Direction_DESC": "descending",
  "TransferMarket_WinterTransferClosesAt": "Extra Transfer window closes in",
  "TransferMarket_WinterTransferClosesOn": "Extra Transfer window closes on",
  "TransferMarket_WinterTransferNoTransactions": "Empty",
  "TransferMarket_WinterTransferOpensAt": "Extra Transfer window opens in",
  "TransferMarket_WinterTransferOpensOn": "Extra Transfer window opens on",
  "TransferMarket_WinterTransferTransaction": "Extra Transfer",
  "Help_Transfers": "Transfers",
  "Help_ResetLineup": "Reset lineup",
  "Help_ResetConfirmation": "Do you really want to reset your lineup? Your entire roster will be sold, your budget will be reset, and your statistics and rankings will be deleted. This action cannot be undone.",
  "Help_ResetConfirm": "Reset",
  "Help_ResetCheckboxLabel": "Yes, I am sure. This action cannot be undone.",
  "Help_Resetting": "Resetting...",
  "Help_ResetSuccess": "Lineup has been reset",
  "Help_ResetError": "Error resetting lineup",
  "Cancel": "Cancel",
  "TrendText_down": "worsens",
  "TrendText_missing": "Calculating",
  "TrendText_unchanged": "unchanged",
  "TrendText_undefined": "new",
  "TrendText_up": "Improved",
  "GroupViewLegend": {
    "GroupMemberLedgerState": {
      "FULL": "Valid lineup",
      "EMPTY_OR_PARTIAL": "Partial Lineup",
      "NONE": "No Lineup yet"
    }
  },
  "UserDetails_Points": "Point Overview",
  "UserDetails_TotalPoints": "total",
  "UserDetails_AveragePoints": "Ø",
  "UserDetails_MissedPoints": " / missed"
}
